export function createUuid(): string {
  // Prefer modern browser uuid if available.
  const cryptoAny = (globalThis as any).crypto as Crypto | undefined;
  if (cryptoAny && 'randomUUID' in cryptoAny && typeof (cryptoAny as any).randomUUID === 'function') {
    return (cryptoAny as any).randomUUID();
  }

  // RFC4122-ish v4 fallback
  const bytes = new Uint8Array(16);
  if (cryptoAny?.getRandomValues) {
    cryptoAny.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
  }

  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0'));
  return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex
    .slice(8, 10)
    .join('')}-${hex.slice(10, 16).join('')}`;
}

